export default __webpack_public_path__ + "static/media/research.7a5b9079.svg";